import { CampaignByProductIdDto } from '@dto/campaign/campaign-by-product-id.dto';
import { CampaignDto, DraftCampaignDto, ScheduledCampaignDto } from '@dto/campaign/campaign.dto';
import { createAction, props } from '@ngrx/store';
import { TeamsCampaignFilter } from '@entity/teams-campaign-filter.entity';

const state = '[Campaign]';
// Campaign list
export const changeCampaignListFilters = createAction(
  `${state} Change campaign list filter`,
  props<{ filters: TeamsCampaignFilter }>()
);

// Init campaign
export const initCampaignByProductIds = createAction(
  `${state} Init campaign by productIds`,
  props<{ productIds: string[] }>()
);
export const initCampaignByProductIdsSuccess = createAction(
  `${state} Init campaign by productIds success`,
  props<{ campaignByProductId: CampaignByProductIdDto }>()
);
export const initCampaignByProductIdsFailure = createAction(
  `${state} Init campaign by productIds failure`,
  props<{ error: string }>()
);

// Send campaign
export const sendCampaign = createAction(
  `${state} Send campaign`,
  props<{ campaign: CampaignDto }>()
);
export const sendCampaignSuccess = createAction(
  `${state} Send campaign success`,
  props<{ campaign: CampaignDto }>()
);
export const sendCampaignFailure = createAction(
  `${state} Send campaign failure`,
  props<{ error: string }>()
);

// Save campaign
export const saveCampaign = createAction(
  `${state} Save campaign`,
  props<{ campaign: DraftCampaignDto }>()
);
export const saveCampaignSuccess = createAction(
  `${state} Save campaign success`,
  props<{ campaign: DraftCampaignDto }>()
);
export const saveCampaignFailure = createAction(
  `${state} Save campaign failure`,
  props<{ error: string }>()
);

// Schedule campaign
export const scheduleCampaign = createAction(
  `${state} Schedule campaign`,
  props<{ campaign: ScheduledCampaignDto }>()
);
export const scheduleCampaignSuccess = createAction(
  `${state} Schedule campaign success`,
  props<{ campaign: ScheduledCampaignDto }>()
);
export const scheduleCampaignFailure = createAction(
  `${state} Schedule campaign failure`,
  props<{ error: string }>()
);

// Delete campaign
export const deleteCampaign = createAction(
  `${state} Delete campaign`,
  props<{ campaignId: string }>()
);
export const deleteCampaignSuccess = createAction(
  `${state} Delete campaign success`,
  props<{ campaignId: string }>()
);
export const deleteCampaignFailure = createAction(
  `${state} Delete campaign failure`,
  props<{ error: string }>()
);